module.exports = __webpack_public_path__ + "static/pyohio-sprints-4-8174080c661fc34ac75df7c293b7f186.jpg";